export enum BetDetailType {
  NormalMainGame = 1,
  NormalFreeGame = 2,
  GodziMainGame = 3,
  GodziFreeGame = 4,
}

export enum DetailGameType {
  None = 0,
  Main = 1,
  Free = 2,
  Prize = 3,
}

export enum BetDetailTab {
  None = 0,
  Normal = 1,
  Godzi = 2,
}
